/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { changeOrgUnit } from '../fn/user-profile/change-org-unit';
import { ChangeOrgUnit$Params } from '../fn/user-profile/change-org-unit';
import { getCurrentUser } from '../fn/user-profile/get-current-user';
import { GetCurrentUser$Params } from '../fn/user-profile/get-current-user';
import { getUserConfig } from '../fn/user-profile/get-user-config';
import { GetUserConfig$Params } from '../fn/user-profile/get-user-config';
import { PersonConfigDto } from '../models/person-config-dto';
import { PersonDto } from '../models/person-dto';
import { switchTenant } from '../fn/user-profile/switch-tenant';
import { SwitchTenant$Params } from '../fn/user-profile/switch-tenant';

@Injectable({ providedIn: 'root' })
export class UserProfileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `switchTenant()` */
  static readonly SwitchTenantPath = '/api/userprofile/switch-tenant';

  /**
   * To switch to a different tenant as a DIANA admin user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `switchTenant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  switchTenant$Response(params: SwitchTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonDto>> {
    return switchTenant(this.http, this.rootUrl, params, context);
  }

  /**
   * To switch to a different tenant as a DIANA admin user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `switchTenant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  switchTenant(params: SwitchTenant$Params, context?: HttpContext): Observable<PersonDto> {
    return this.switchTenant$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonDto>): PersonDto => r.body)
    );
  }

  /** Path part for operation `changeOrgUnit()` */
  static readonly ChangeOrgUnitPath = '/api/userprofile/change-org-unit';

  /**
   * To change the org unit, if a user has access to multiple org units
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeOrgUnit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeOrgUnit$Response(params: ChangeOrgUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonDto>> {
    return changeOrgUnit(this.http, this.rootUrl, params, context);
  }

  /**
   * To change the org unit, if a user has access to multiple org units
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeOrgUnit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeOrgUnit(params: ChangeOrgUnit$Params, context?: HttpContext): Observable<PersonDto> {
    return this.changeOrgUnit$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonDto>): PersonDto => r.body)
    );
  }

  /** Path part for operation `getCurrentUser()` */
  static readonly GetCurrentUserPath = '/api/userprofile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser$Response(params?: GetCurrentUser$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonDto>> {
    return getCurrentUser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser(params?: GetCurrentUser$Params, context?: HttpContext): Observable<PersonDto> {
    return this.getCurrentUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonDto>): PersonDto => r.body)
    );
  }

  /** Path part for operation `getUserConfig()` */
  static readonly GetUserConfigPath = '/api/userprofile/config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserConfig$Response(params?: GetUserConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonConfigDto>> {
    return getUserConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserConfig(params?: GetUserConfig$Params, context?: HttpContext): Observable<PersonConfigDto> {
    return this.getUserConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonConfigDto>): PersonConfigDto => r.body)
    );
  }

}
